import type React from "react";
import EditingInformationPanel from "@/features/editing/components/EditingInformationPanel";
import LeftPanelTabs from "@/features/notebook/components/LeftPanelTabs";
import type { LeftPanelSwitcherProps } from "@/features/notebook/types/notebook";

const mapEdgesForEditing = (props: LeftPanelSwitcherProps) =>
	props.graphEdges.map((edge) => ({
		id: edge.id,
		predicateId: edge.predicateId,
		tupleId: edge.tupleId,
		source: typeof edge.source === "string" ? edge.source : edge.source.id,
		target: typeof edge.target === "string" ? edge.target : edge.target.id,
		label: edge.label,
	}));

const LeftPanelSwitcher: React.FC<LeftPanelSwitcherProps> = (props) => {
	if (props.isEditing) {
		return (
			<EditingInformationPanel
				selectedNode={props.selectedNode}
				visible={props.isEditingPanelVisible}
				onToggle={props.onToggleEditingPanel}
				onDeleteNode={props.onDeleteNode}
				graphId={props.graphId}
				onGraphUpdate={() => {}}
				graphNodes={props.graphNodes}
				edges={mapEdgesForEditing(props)}
			/>
		);
	}

	return (
		<LeftPanelTabs
			selectedSources={props.selectedSources}
			onSourceToggle={props.onSourceToggle}
			onSelectAll={props.onSelectAll}
			onGraphGenerated={props.onGraphGenerated}
			workspaceId={props.workspaceId}
			graphStatistics={props.graphStatistics}
			graphId={props.graphId}
			graphNodes={props.graphNodes}
			graphEdges={props.graphEdges}
			selectedNodeId={props.selectedNodeId}
			selectedEdgeId={props.selectedEdgeId}
			onFilter={props.onFilter}
			onResetFilter={props.onResetFilter}
		/>
	);
};

export default LeftPanelSwitcher;
